/* TELVYX Vehicle Selector
 * Stores selection in localStorage key: telvyx_vehicle
 * Updates header badge
 * Redirects "All Compatible Products" to /collections/<model-handle>
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'telvyx_vehicle';

  function safeParse(json) {
    try { return JSON.parse(json); } catch (e) { return null; }
  }

  function readVehicle() { return safeParse(window.localStorage.getItem(STORAGE_KEY) || ''); }

  function writeVehicle(vehicle) {
    try { window.localStorage.setItem(STORAGE_KEY, JSON.stringify(vehicle)); } catch (e) {}
  }

  function vehicleLabel(vehicle) {
    if (!vehicle || !vehicle.model) return '';
    var modelMap = {
      'model-3': 'Model 3',
      'model-y': 'Model Y',
      'model-s': 'Model S',
      'model-x': 'Model X',
      'cybertruck': 'Cybertruck'
    };
    var m = modelMap[vehicle.model] || vehicle.model;
    var y = vehicle.year ? ' ' + vehicle.year : '';
    return m + y;
  }

  function setAriaHidden(el, hidden) { if (el) el.setAttribute('aria-hidden', hidden ? 'true' : 'false'); }

  function openModal(modal) {
    if (!modal) return;
    modal.classList.add('is-open');
    setAriaHidden(modal, false);
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    setAriaHidden(modal, true);
  }

  function populateYears(selectEl) {
    if (!selectEl) return;
    var now = new Date().getFullYear();
    var start = 2012;
    for (var y = now + 1; y >= start; y--) {
      var opt = document.createElement('option');
      opt.value = String(y);
      opt.textContent = String(y);
      selectEl.appendChild(opt);
    }
  }

  function updateHeaderBadges() {
    var badges = document.querySelectorAll('[data-telvyx-vehicle-badge]');
    var v = readVehicle();
    var label = vehicleLabel(v);
    badges.forEach(function (badge) {
      if (!badge) return;
      if (label) {
        // desktop badge uses text; mobile dot badge hides text via CSS
        badge.textContent = label;
        badge.hidden = false;
      } else {
        badge.textContent = '';
        badge.hidden = true;
      }
    });
  }

  function prefillForm(modal) {
    if (!modal) return;
    var yearEl = modal.querySelector('[data-telvyx-vehicle-year]');
    var modelEl = modal.querySelector('[data-telvyx-vehicle-model]');
    var variantEl = modal.querySelector('[data-telvyx-vehicle-variant]');
    var v = readVehicle();
    if (!v) return;
    if (yearEl && v.year) yearEl.value = String(v.year);
    if (modelEl && v.model) modelEl.value = v.model;
    if (variantEl && v.variant) variantEl.value = v.variant;
  }

  function wire() {
    var modal = document.getElementById('TELVYXVehicleModal');
    if (!modal) return;

    populateYears(modal.querySelector('[data-telvyx-vehicle-year]'));

    document.querySelectorAll('[data-telvyx-vehicle-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        prefillForm(modal);
        openModal(modal);
      });
    });

    modal.querySelectorAll('[data-telvyx-vehicle-close]').forEach(function (btn) {
      btn.addEventListener('click', function () { closeModal(modal); });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(modal);
    });

    var saveBtn = modal.querySelector('[data-telvyx-vehicle-save]');
    if (saveBtn) {
      saveBtn.addEventListener('click', function () {
        var yearEl = modal.querySelector('[data-telvyx-vehicle-year]');
        var modelEl = modal.querySelector('[data-telvyx-vehicle-model]');
        var variantEl = modal.querySelector('[data-telvyx-vehicle-variant]');
        var vehicle = {
          year: yearEl && yearEl.value ? yearEl.value : '',
          model: modelEl && modelEl.value ? modelEl.value : '',
          variant: variantEl && variantEl.value ? variantEl.value : ''
        };
        writeVehicle(vehicle);
        updateHeaderBadges();
        closeModal(modal);
      });
    }

    var compatLink = modal.querySelector('[data-telvyx-vehicle-compatible]');
    if (compatLink) {
      compatLink.addEventListener('click', function (e) {
        var v = readVehicle();
        if (v && v.model) {
          e.preventDefault();
          window.location.href = '/collections/' + v.model;
        }
      });
    }

    updateHeaderBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire);
  } else {
    wire();
  }
})();
